export const STATES = {
    CREATED: 'CREATED',
    ASSIGNED: 'ASSIGNED',
    STARTED: 'STARTED',
    SUSPENDED: 'SUSPENDED',
    CLOSED: 'CLOSED',
    RESIGNED: 'RESIGNED'
}

export const STATE_NAMES = {
    [STATES.CREATED]: 'Nowe',
    [STATES.ASSIGNED]: 'Przydzielone',
    [STATES.STARTED]: 'W trakcie',
    [STATES.SUSPENDED]: 'Zawieszone',
    [STATES.CLOSED]: 'Zamknięte',
    [STATES.RESIGNED]: 'Wycofane'
}

export const STATE_LABELS = {
    [STATES.CREATED]: {
        text: 'Nowe',
        class: 'is-info'
    },
    [STATES.ASSIGNED]: {
        text: 'Przydzielone',
        class: 'is-primary'
    },
    [STATES.STARTED]: {
        text: 'W trakcie',
        class: 'is-success'
    },
    [STATES.SUSPENDED]: {
        text: 'Zawieszone',
        class: 'is-warning',
        icon: 'Info',
        tooltip: 'Napotkaliśmy problem przy procesowaniu zgłoszenia. Po jego usunięciu prace zostaną wznowione.'
    },
    [STATES.CLOSED]: {
        text: 'Zamknięte',
        class: 'is-gray'
    },
    [STATES.RESIGNED]: {
        text: 'Wycofane',
        class: 'is-danger'
    }
}